(() => {
  if (window.__jmtStorefront) return;
  window.__jmtStorefront = true;

  const colours = ['Light Blue', 'Blue', 'Black'];

  // Fixed-colour Classics product only: no selected colour survives navigation.
  function initSingle(root) {
    if (root.dataset.jmtBound) return;
    root.dataset.jmtBound='true';
    const parse = sel => { try { return JSON.parse(root.querySelector(sel)?.textContent || 'null'); } catch(e) { console.error('Classics JSON',e); return null; } };
    const selected = parse('[data-jmt-single-data]');
    const gallery = parse('[data-jmt-gallery]');
    const catalog = parse('[data-jmt-catalog]') || [];
    if (!selected || !Array.isArray(gallery) || gallery.length!==7) { console.error('Classics single-colour data incomplete'); return; }
    const id = String(selected.variant_id);
    const field=root.querySelector('[data-jmt-variant]');
    if (field) field.value=id;
    const url = new URL(location.href);
    url.searchParams.delete('colour');
    url.searchParams.set('variant',id);
    if (url.href !== location.href) history.replaceState(null,'',url.pathname+url.search+url.hash);
    root.querySelectorAll('[data-jmt-letter]').forEach(link=>{
      const target=catalog.find(p=>p.handle==='type-'+link.dataset.jmtLetter.toLowerCase()+'-hats');
      if (!target) return;
      const next=new URL(target.url,location.origin);
      if (target.variant_id) next.searchParams.set('variant',String(target.variant_id));
      link.href=next.pathname+next.search;
    });
    const hero=root.querySelector('[data-jmt-hero]');
    const strip=root.querySelector('[data-jmt-thumbs]');
    let generation=0;
    const activate=(view)=>{
      const image=gallery.find(x=>x.view===view);
      if (!image || !hero) return;
      const id=++generation;
      hero.dataset.jmtLoaded='false';
      hero.dataset.jmtViewKey=image.view;
      hero.alt=image.alt;
      hero.onload=()=>{if(id===generation)hero.dataset.jmtLoaded=String(Boolean(hero.naturalWidth));};
      hero.onerror=()=>{if(id===generation)hero.dataset.jmtLoaded='false';};
      hero.src=image.src;
      if (hero.complete && hero.naturalWidth)hero.dataset.jmtLoaded='true';
      strip?.querySelectorAll('[data-jmt-view-key]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.jmtViewKey===view)));
    };
    strip?.addEventListener('click',event=>{
      const b=event.target.closest('[data-jmt-view-key]');
      if (!b || !strip.contains(b))return;
      activate(b.dataset.jmtViewKey);
      if (b.offsetLeft < strip.scrollLeft || b.offsetLeft+b.offsetWidth > strip.scrollLeft+strip.clientWidth) b.scrollIntoView({behavior:'auto',block:'nearest',inline:'nearest'});
    });
    root.querySelectorAll('[data-jmt-quantity]').forEach(button=>button.addEventListener('click',()=>{
      const field=root.querySelector('input[name=quantity]');
      if (field)field.value=Math.max(1,(Number(field.value)||1)+Number(button.dataset.jmtQuantity));
    }));
    window.addEventListener('popstate',()=>{
      const current=new URL(location.href);
      if(current.searchParams.get('variant')!==id||current.searchParams.has('colour')){
        current.searchParams.delete('colour');current.searchParams.set('variant',id);
        history.replaceState(null,'',current.pathname+current.search+current.hash);
      }
    });
  }

  function init(root) {
    if (root.dataset.jmtSingle === 'true') return initSingle(root);
    if (root.dataset.jmtSingleCollection === 'true') { root.dataset.jmtBound='true'; return; }
    if (root.dataset.jmtBound) return;
    root.dataset.jmtBound = 'true';
    const view = root.dataset.jmtView;
    if (!['hats', 'product'].includes(view)) return;

    const parse = selector => {
      const source = root.querySelector(selector);
      if (!source) return null;
      try { return JSON.parse(source.textContent); }
      catch (error) { console.error('JMT gallery JSON invalid', error); return null; }
    };
    const catalog = parse('[data-jmt-catalog]') || [];
    const fronts = parse('[data-jmt-front]') || {};
    const galleries = parse('[data-jmt-gallery]') || {};
    const product = parse('[data-jmt-product-data]');
    const find = (p, c) => p && p.variants.find(v => (v.options || [v.option1]).includes(c));

    const colourFromURL = () => {
      const params = new URLSearchParams(location.search);
      const v = product && product.variants.find(item => String(item.id) === params.get('variant'));
      const candidate = v ? (v.options || [v.option1])[0] : params.get('colour');
      return colours.includes(candidate) ? candidate : 'Blue';
    };
    let selected = colourFromURL();
    let activeView = 'front';
    let generation = 0;
    const galleryStrip = root.querySelector('[data-jmt-thumbs]');
    const hero = root.querySelector('[data-jmt-hero]');

    function keepThumbVisible(button) {
      if (!button || !galleryStrip || galleryStrip.scrollWidth <= galleryStrip.clientWidth) return;
      const strip = galleryStrip.getBoundingClientRect();
      const item = button.getBoundingClientRect();
      if (item.left < strip.left) galleryStrip.scrollLeft -= strip.left - item.left + 4;
      if (item.right > strip.right) galleryStrip.scrollLeft += item.right - strip.right + 4;
    }

    function showView(item, scrollThumbnail = false) {
      if (!hero || !item) return;
      activeView = item.view;
      const request = ++generation;
      hero.alt = item.alt;
      hero.dataset.jmtViewKey = item.view;
      hero.dataset.jmtActiveColour = selected;
      hero.onload = () => {
        if (request === generation) {
          hero.dataset.jmtLoaded = hero.naturalWidth ? 'true' : 'false';
        }
      };
      hero.onerror = () => {
        if (request === generation) hero.dataset.jmtLoaded = 'false';
      };
      hero.dataset.jmtLoaded = 'false';
      hero.src = item.src;
      if (hero.complete && hero.naturalWidth) hero.dataset.jmtLoaded = 'true';
      let current;
      if (galleryStrip) {
        galleryStrip.querySelectorAll('[data-jmt-view-key]').forEach(button => {
          const active = button.dataset.jmtViewKey === item.view;
          button.setAttribute('aria-pressed', String(active));
          if (active) current = button;
        });
      }
      if (scrollThumbnail) keepThumbVisible(current);
    }

    function renderGallery(colour) {
      if (!galleryStrip) return;
      const items = galleries[colour] || [];
      if (!items.length) return;
      const matching = items.find(i => i.view === activeView) || items[0];
      const fragment = document.createDocumentFragment();
      items.forEach(item => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jmt-thumb';
        button.dataset.jmtViewKey = item.view;
        button.setAttribute('aria-pressed', String(item.view === matching.view));
        button.setAttribute('aria-label', item.alt);
        const thumbImage = document.createElement('img');
        thumbImage.src = item.src;
        thumbImage.alt = item.alt;
        thumbImage.loading = 'lazy';
        thumbImage.width = 1200;
        thumbImage.height = 1200;
        button.appendChild(thumbImage);
        fragment.appendChild(button);
      });
      galleryStrip.replaceChildren(fragment);
      showView(matching, true);
    }

    function apply(colour, syncURL = true) {
      if (!colours.includes(colour)) return;
      selected = colour;
      root.querySelectorAll('[data-jmt-colour]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.jmtColour === colour));
      });
      root.querySelectorAll('[data-jmt-colour-name]').forEach(name => name.textContent = colour);
      const url = new URL(location.href);
      url.searchParams.set('colour', colour);
      if (view === 'hats') {
        root.querySelectorAll('[data-jmt-product]').forEach(card => {
          const p = catalog.find(row => String(row.id) === card.dataset.jmtProduct);
          if (!p) return;
          const v = find(p, colour);
          const link = new URL(p.url, location.origin);
          link.searchParams.set('colour', colour);
          if (v) link.searchParams.set('variant', v.id);
          card.href = link.pathname + link.search;
          const readyFront = (p.fronts && p.fronts[colour]) || (p.handle === 'type-a-hats' ? fronts[colour] : null);
          if (readyFront) {
            const img = card.querySelector('img');
            if (img) {
              img.src = readyFront;
              img.removeAttribute('srcset');
              img.alt = p.handle + ' ' + colour;
            }
          }
        });
      } else {
        const v = find(product, colour);
        if (v) {
          const field = root.querySelector('[data-jmt-variant]');
          if (field) field.value = v.id;
          url.searchParams.set('variant', v.id);
        }
        root.querySelectorAll('[data-jmt-back]').forEach(link => {
          const u = new URL(link.href);
          u.searchParams.set('colour', colour);
          link.href = u.pathname + u.search;
        });
        root.querySelectorAll('[data-jmt-letter]').forEach(link => {
          const target = catalog.find(p => p.handle === 'type-' + link.dataset.jmtLetter.toLowerCase() + '-hats');
          if (!target) return;
          const variant = find(target, colour);
          const u = new URL(target.url, location.origin);
          u.searchParams.set('colour', colour);
          if (variant) u.searchParams.set('variant', variant.id);
          link.href = u.pathname + u.search;
        });
        if ((galleries[colour] || []).length) renderGallery(colour);
      }
      if (syncURL) history.replaceState(null, '', url.pathname + url.search + url.hash);
    }

    root.querySelectorAll('[data-jmt-colour]').forEach(button => {
      button.addEventListener('click', () => apply(button.dataset.jmtColour));
    });
    if (galleryStrip) {
      galleryStrip.addEventListener('click', event => {
        const button = event.target.closest('[data-jmt-view-key]');
        if (!button || !galleryStrip.contains(button)) return;
        const item = (galleries[selected] || []).find(x => x.view === button.dataset.jmtViewKey);
        showView(item, true);
      });
    }
    root.querySelectorAll('[data-jmt-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        const field = root.querySelector('input[name=quantity]');
        if (field) field.value = Math.max(1, (Number(field.value) || 1) + Number(button.dataset.jmtQuantity));
      });
    });
    root.querySelector('form')?.addEventListener('submit', event => event.preventDefault());
    apply(selected);
    window.addEventListener('popstate', () => apply(colourFromURL(), false));
  }

  function all() { document.querySelectorAll('[data-jmt-root]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', all);
})();

